import { useEffect, useState } from "react";
import { QuoteApprovalAPI } from "../apis/quote-approval-api";
import { PricingPortalAPI } from "../apis/pricing-api";
import { ToastType, notifyToast } from "../components-old/ComponentsIndex";
import { useNavigate } from "react-router-dom";

const useFetchPdfDoc = (businessCode, countryCode, quoteId, quoteRecord = null, isCoveringManager = false, loggedInUseremail) => {
  const navigate = useNavigate();
  const [documentData, setDocumentData] = useState({
    pdfbinary: "",
    quoteDetails: null,
    actionAllowed: false,
    apiFetchComplete: false,
  });

  useEffect(() => {
    const fetchQuoteDocument = async () => {
      try {
        let quoteDetails = quoteRecord;
        if (!quoteRecord) {
          const quoteResponse = await PricingPortalAPI.getFilterList(
            businessCode,
            countryCode,
            "getQuoteApprovalList",
            "quoteApproval",
            isCoveringManager ? "&coveringManager=true&quoteId=" + quoteId : "&coveringManager=false&quoteId=" + quoteId
          );
          quoteDetails = quoteResponse && quoteResponse.length > 0 ? quoteResponse[0] : null;
        }

        let documentRes = await QuoteApprovalAPI.fetchQuotePricingDocument({
          businessCode,
          countryCode,
          email: quoteDetails.salesPersonEmailId,
          quoteId,
          locale: quoteDetails.locale,
        });

        if (documentRes.isError === true) {
          notifyToast(documentRes.message, ToastType.ERROR);
          navigate("/quotelist");
        } else {
          await setDocumentData((prevState) => ({
            ...prevState,
            pdfbinary: documentRes ? documentRes : "",
            quoteDetails: quoteDetails,
            actionAllowed: isCoveringManager ? isCoveringManager : quoteDetails.approvalAuthorityEmail?.toLowerCase() === loggedInUseremail.toLowerCase(),
            apiFetchComplete: true,
          }));
        }
      } catch (e) {
        notifyToast("Internal server error", ToastType.ERROR);
        navigate("/quotelist");
        // spinnerCtx.setLoadingIndicator(false);
      }
    };
    fetchQuoteDocument();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return documentData;
};

export { useFetchPdfDoc };
